import React, { useEffect, useState } from "react";
import "./App.css";
import { useTheme } from "./hooks/useTheme";
import { PlayerPage } from "./pages/PlayerPage";
import { FeedbackPage } from "./pages/FeedbackPage";
import { configureTestMode } from "./lib/testMode";

function readRoute() {
  configureTestMode();
  const match = window.location.pathname.match(/^\/watch\/([A-Za-z0-9_-]{11})\/?$/);
  return { videoId: match?.[1] || null, feedback: /^\/feedback\/?$/.test(window.location.pathname) };
}

function App() {
  const [route, setRoute] = useState(readRoute);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handlePopState = () => setRoute(readRoute());
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigate = (path) => {
    window.history.pushState({}, "", path);
    setRoute(readRoute());
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return route.feedback ? <FeedbackPage theme={theme} onToggleTheme={toggleTheme} onNavigate={navigate} /> : <PlayerPage videoId={route.videoId} theme={theme} onToggleTheme={toggleTheme} onNavigate={navigate} />;
}

export default App;
